<template>
  <div class="container mx-auto p-4">
    <div class="flex flex-wrap items-center justify-between border-b pb-4">
      <h3 class="font-bold text-lg sm:text-2xl w-full sm:w-auto text-center sm:text-left">
        {{ project.projectsTotal }} {{ project.projectsTotal === 1 ? 'Proyecto' : 'Proyectos' }}
      </h3>
      <BaseButton class="h-10 w-full sm:w-40 ml-0 sm:ml-3 mt-2 sm:mt-0" @click="showCreateModal = true">
        Agregar proyecto
      </BaseButton>
    </div>

    <div class="mt-5">
      <div class="flex flex-wrap -m-4">
        <div v-for="project in project.projects" :key="project.id" class="w-full sm:w-1/2 lg:w-1/3 p-4">
          <ProjectCard :project="project" />
        </div>
      </div>
    </div>

    <ProjectCreateModal
      :tenant="tenant.current"
      :show="showCreateModal"
      @close="showCreateModal = false"
    />
  </div>
</template>

<script>
import store from '@/store';
import { mapState } from 'vuex';
import BaseButton from '@/components/BaseButton';
import ProjectCard from '@/components/ProjectCard';
import ProjectCreateModal from './Projects/components/ProjectCreateModal';

export default {
  components: { BaseButton, ProjectCard, ProjectCreateModal },
  name: 'ProjectList',
  data() {
    return {
      showCreateModal: false,
    };
  },
  computed: {
    ...mapState(['project', 'tenant']),
  },

  beforeRouteEnter(to, from, next) {
    getPageData(to, next);
  },
  beforeRouteUpdate(to, from, next) {
    getPageData(to, next);
  },
};

async function getPageData(to, next) {
  await store.dispatch('project/fetchProjects', to.params.id);
  next();
}
</script>

<style scoped>
.container {
  max-width: 1200px;
}
</style>
